<template>
  <div>
    <div class="row mb-3">
      <div class="col-8 offset-2">
        <Logs :carrier="carrier" />
      </div>
    </div>
  </div>
</template>

<script>
import Logs from './Logs';

export default {
  name: 'CarriersLogs',
  components: { Logs },
  props: {
    carrier: {
      type: Object,
      default: null,
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/carriers/CarriersLogs.vue